import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Skeleton } from "../../../ui/skeleton/skeleton";
export var OnlineSkeleton = function () {
    return (_jsxs("div", { className: "calc-step-form", children: [_jsx(Skeleton, { height: "48px" }), _jsx(Skeleton, { width: "100%", height: "100px" }), _jsx(Skeleton, { width: "100%", height: "100px" }), _jsx(Skeleton, { width: "360px", height: "32px" })] }));
};
